var AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
var AUTH_SCOPE = process.env.REACT_APP_AUTH_SCOPE;
export var msalConfig = {
    auth: {
        clientId: AUTH_CLIENT_ID !== null && AUTH_CLIENT_ID !== void 0 ? AUTH_CLIENT_ID : '',
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: '/',
        postLogoutRedirectUri: '/'
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    }
};
export var loginRequest = {
    scopes: [AUTH_SCOPE]
};
